/* istanbul ignore file */
import Vue from "vue";
import Carousel from "./StoreCarousel";

const vueElQuery = "[data-vue-app='carousel']";
const vueView = "[data-vue-view]";

document.ready.then(() => {
  const isVueView = document.querySelectorAll(vueView).length > 0;

  if (document.querySelector(vueElQuery) && !isVueView) {
    for (let vueEl of document.querySelectorAll(vueElQuery)) {
      new Vue({
        el: vueEl,
        components: {
          carousel: Carousel,
        },
        mounted() {
          window._lytics_.attachEventListeners(this.$el);
        },
      });
    }
  }
});
